import { ApiResponse, ResponseError } from '@marketplace-web/core-api/api-client-util'

const PASSWORD_CHANGE_RESTRICTED_ERROR =
  'This account has a special role, so for security reasons it can’t have a password.'

export const isPasswordChangeRestricted = (response: ApiResponse | ResponseError<unknown>) => {
  if (!('errors' in response)) return false

  return response.errors.some(({ value }) => value === PASSWORD_CHANGE_RESTRICTED_ERROR)
}
